export default {
  BusinessOrderPreemptGoods: {
    skuTitle: '按商品汇总',
    skuItemTitle: '按商品行明细',
    reReserve: '重新预占',
    reReserveConfirmText1: '是否确认重新预占？',
    Uncamp: '解除预占',
    preemptConfirmText: '是否确认解除预占？'
  },
  BusinessOrderPreemptGoodsSku: {
    preemptionStatus: '预占状态',
    reReserve: '重新预占',
    Uncamp: '解除预占',
    reserve: '待预占',
    reserveOk: '预占成功',
    reserveFail: '预占失败',
    hangUp: '挂起',
    giveaway: '是否赠品',
    sourceStatus: '寻源状态',
    virtualWarehouseName: '预占虚仓',
    failReason: '失败原因',
    productLineTotal: '商品行总数',
    quantity: '商品数量',
    other: '其它信息',
    msgWarning: '返回数据为空，请联系管理员'
  }
};
